define('view/helper/TemplatePartials',['require','handlebars','view/helper/TemplatePrecompiled'],function (require) {

	var Handlebars = require('handlebars');
	var templateFor = require('view/helper/TemplatePrecompiled').templateFor;

	// Register partials as precompiled functions when the theme bundle provides them (no runtime
	// Handlebars.compile → no 'unsafe-eval'); templateFor falls back to the raw DOM string otherwise.
    Handlebars.registerPartial('bookingInfoPart', templateFor('#booking_info_part'));
    Handlebars.registerPartial('bookingInfoPartPrice', templateFor('#booking_info_part_price'));
    Handlebars.registerPartial('bookingInfoSideBarPart', templateFor('#datetime_booking_info_sidebar'));
    Handlebars.registerPartial('bookingInfoSideBarListPart', templateFor('#datetime_booking_info_sidebar_list'));
    Handlebars.registerPartial('bookingTimeLegendPart', templateFor('#time_legend_part'));
    Handlebars.registerPartial('bookingPackageLink', templateFor('#booking_details_package_link'));
    Handlebars.registerPartial('preloaderPart', templateFor('#preloader_part'));
    Handlebars.registerPartial('emptyTimePart', templateFor('#empty_time_part'));
    Handlebars.registerPartial('emptyWeekTimePart', templateFor('#empty_week_time_part'));
    Handlebars.registerPartial('mainPageContactsPart', templateFor('#index_contacts_part'));
    Handlebars.registerPartial('mainPageAboutUsPart', templateFor('#index_about_us_part'));
    Handlebars.registerPartial('mainPageWorkingHoursPart', templateFor('#index_working_hours_part'));
    Handlebars.registerPartial('formInput', templateFor('#part_form_input'));
    Handlebars.registerPartial('formEmail', templateFor('#part_form_email'));
    Handlebars.registerPartial('formPhone', templateFor('#part_form_phone'));
    Handlebars.registerPartial('formPassword', templateFor('#part_form_password'));
    Handlebars.registerPartial('formSelect', templateFor('#part_form_select'));
    Handlebars.registerPartial('formCheckbox', templateFor('#part_form_checkbox'));
    Handlebars.registerPartial('formLabel', templateFor('#part_form_label'));
    Handlebars.registerPartial('formLabelSelect', templateFor('#part_form_label_select'));
    Handlebars.registerPartial('serviceBar', templateFor('#service_bar'));
    Handlebars.registerPartial('gdprReportTable', templateFor('#gdpr_report_table'));
    Handlebars.registerPartial('gdprReportTableBookings', templateFor('#gdpr_report_table_bookings'));
    Handlebars.registerPartial('gdprReportTableSoapCrypt', templateFor('#gdpr_report_table_soap_crypt'));
    Handlebars.registerPartial('gdprReportTableSoap', templateFor('#gdpr_report_table_soap'));
    Handlebars.registerPartial('cookiesBlock', templateFor('#cookies_block'));
    Handlebars.registerPartial('userTermsAndConditionsLink', templateFor('#user_terms_and_conditions'));
    Handlebars.registerPartial('termsAndConditionsLang', templateFor('#terms_and_conditions_lang'));
    Handlebars.registerPartial('footer', templateFor('#footer_part'));

});

